import React, { useEffect, useId, useRef, useState } from 'react';
import './PedidosExclusaoConta.css';

const formatarData = value => value ? new Date(value).toLocaleString('pt-BR') : 'Não informada';
const nomesPerfis = { usuario: 'Normal', normal: 'Normal', lojista: 'Lojista', moderador: 'Moderador', admin: 'Administrador', administrador: 'Administrador', tecnico: 'Técnico' };
const formatarPerfis = perfis => {
  const nomes = (Array.isArray(perfis) ? perfis : []).map(perfil => {
    const key = String(perfil || '').trim().toLowerCase();
    return nomesPerfis[key] || key;
  }).filter(Boolean);
  return [...new Set(nomes)].join(', ') || 'Não informado';
};

export default function PedidosExclusaoConta({ gerenciar, somenteConsulta, aguardandoReautenticacao, onBusyChange }) {
  const [pedidos, setPedidos] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [carregado, setCarregado] = useState(false);
  const [ocupado, setOcupado] = useState('');
  const [erro, setErro] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [detalhes, setDetalhes] = useState(null);
  const [modalAberto, setModalAberto] = useState(false);
  const [confirmando, setConfirmando] = useState(false);
  const [confirmacao, setConfirmacao] = useState('');
  const dialogRef = useRef(null);
  const titleId = useId();
  const inputId = useId();
  const mostrarModal = modalAberto && !aguardandoReautenticacao;
  useEffect(() => {
    const dialog = dialogRef.current;
    if (mostrarModal && !dialog.open) dialog.showModal();
    if (!mostrarModal && dialog.open) dialog.close();
    return () => { if (dialog.open) dialog.close(); };
  }, [mostrarModal]);
  function busy(value) { setOcupado(value); onBusyChange(Boolean(value)); }
  async function listar(mais = false) {
    if (ocupado) return;
    busy('lista'); setErro(''); setMensagem('');
    try {
      const result = await gerenciar({ action: 'list_account_deletion_requests', pageSize: 25, cursorDocId: mais ? cursor : null });
      setPedidos(previous => mais ? [...previous, ...result.requests.filter(item => !previous.some(old => old.id === item.id))] : result.requests);
      setCursor(result.nextCursorDocId); setCarregado(true);
    } catch (error) { setErro(error.message || 'Não foi possível consultar os pedidos.'); }
    finally { busy(''); }
  }
  async function visualizar(pedido, excluir = false) {
    if (ocupado) return;
    busy('analise'); setErro(''); setMensagem(''); setDetalhes(null);
    setConfirmando(excluir); setConfirmacao(''); setModalAberto(true);
    try {
      const result = await gerenciar({ action: 'get_account_deletion_request', requestId: pedido.id });
      setDetalhes(result);
    } catch (error) { setErro(error.message || 'Não foi possível analisar o pedido.'); }
    finally { busy(''); }
  }
  async function excluir(event) {
    event.preventDefault();
    if (ocupado || somenteConsulta || !detalhes?.elegivel || confirmacao !== 'CONFIRMAR') return;
    busy('exclusao'); setErro('');
    try {
      await gerenciar({ action: 'delete_account_request', requestId: detalhes.request.id, requestVersion: detalhes.request.versao, confirmation: confirmacao });
      setPedidos(previous => previous.filter(item => item.id !== detalhes.request.id));
      setModalAberto(false); setDetalhes(null); setConfirmacao('');
      setMensagem('Conta excluída e pedido concluído.');
    } catch (error) {
      setErro(`${error.message || 'A exclusão foi interrompida.'} Visualize o pedido novamente para revalidar antes de tentar outra vez.`);
      setDetalhes(previous => previous ? { ...previous, elegivel: false } : previous);
      setConfirmacao('');
    } finally { busy(''); }
  }
  return <div>
    <div className="routine-actions" style={{ marginBottom: 16 }}>
      <button type="button" className="routine-btn routine-btn--primary" onClick={() => listar()} disabled={Boolean(ocupado)}>{ocupado === 'lista' ? 'Consultando...' : carregado ? 'Atualizar pedidos' : 'Consultar pedidos'}</button>
    </div>
    {somenteConsulta && <p className="routine-callout__text">Somente administradores podem excluir contas. Seu perfil permite apenas visualizar os pedidos.</p>}
    {mensagem && <p className="routine-callout__text" role="status">{mensagem}</p>}
    {erro && !modalAberto && <p className="routine-callout__text" role="alert">{erro}</p>}
    {!carregado ? <div className="routine-empty">Clique em Consultar pedidos para carregar as solicitações. Nenhuma exclusão é feita nesta consulta.</div> : pedidos.length === 0 ? <div className="routine-empty">Nenhum pedido pendente nesta lista.</div> : <div className="routine-table-wrap">
      <table className="routine-table"><thead><tr><th>Conta</th><th>Solicitado em</th><th>Ações</th></tr></thead><tbody>
        {pedidos.map(pedido => <tr key={pedido.id}>
          <td><div className="admin-user-card"><strong className="admin-user-card__name">{pedido.nome || 'Conta sem nome'}</strong><span className="admin-user-card__email">{pedido.email || 'E-mail não informado'}</span>{pedido.emProcessamento && <span className="routine-status routine-status--warning">Em processamento</span>}</div></td>
          <td>{formatarData(pedido.criadaEm)}</td>
          <td><div className="admin-actions-row">
            <button type="button" className="routine-btn routine-btn--soft" disabled={Boolean(ocupado)} onClick={() => visualizar(pedido)}>Visualizar</button>
            {!somenteConsulta && <button type="button" className="routine-btn routine-btn--danger" disabled={Boolean(ocupado) || pedido.emProcessamento} onClick={() => visualizar(pedido, true)}>Excluir conta</button>}
          </div></td>
        </tr>)}
      </tbody></table>
    </div>}
    {cursor && <button type="button" className="routine-btn routine-btn--soft" disabled={Boolean(ocupado)} onClick={() => listar(true)} style={{ marginTop: 16 }}>Carregar mais</button>}
    <dialog ref={dialogRef} className="panel-compact-dialog account-deletion-dialog" aria-labelledby={titleId} aria-busy={Boolean(ocupado)} onCancel={event => { if (ocupado) event.preventDefault(); else setModalAberto(false); }}>
      <div className="account-deletion-dialog__header"><h3 id={titleId}>{ocupado === 'exclusao' ? 'Excluindo conta' : 'Pedido de exclusão de conta'}</h3><button type="button" className="routine-btn routine-btn--soft" disabled={Boolean(ocupado)} onClick={() => setModalAberto(false)}>Fechar</button></div>
      {ocupado === 'analise' && <p role="status">Conferindo o pedido e as condições da conta. Nenhuma exclusão nesta etapa.</p>}
      {ocupado === 'exclusao' && <p role="status" aria-live="polite">Removendo os dados e, ao final, o acesso da conta. Aguarde sem fechar a página.</p>}
      {detalhes && <>
        <dl className="account-deletion-dialog__details">
          <dt>Nome</dt><dd>{detalhes.account.nome || detalhes.request.nome || 'Não informado'}</dd>
          <dt>E-mail</dt><dd>{detalhes.account.email || detalhes.request.email || 'Não informado'}</dd>
          <dt>Solicitado em</dt><dd>{formatarData(detalhes.request.criadaEm)}</dd>
          <dt>Motivo informado</dt><dd>{detalhes.request.motivo || 'Não informado'}</dd>
          <dt>Tipo de usuário</dt><dd>{formatarPerfis(detalhes.account.perfis)}</dd>
        </dl>
        {detalhes.motivoBloqueio && <div className="routine-callout routine-callout--warm"><p className="routine-callout__text">{detalhes.motivoBloqueio}</p></div>}
        {detalhes.request.tentativaAnterior && <p className="routine-callout__text">Houve uma tentativa anterior. A conta foi revalidada para permitir a retomada das etapas restantes.</p>}
        {!somenteConsulta && detalhes.elegivel && (confirmando ? <form onSubmit={excluir}>
          <div className="routine-callout routine-callout--warm"><p className="routine-callout__text">Esta ação é permanente e usa o mesmo processo de exclusão do app: remove dados, publicações, imagens e o acesso da conta.</p></div>
          <label htmlFor={inputId}>Digite CONFIRMAR para excluir esta conta</label>
          <input id={inputId} className="routine-input" value={confirmacao} onChange={event => setConfirmacao(event.target.value)} disabled={Boolean(ocupado)} autoComplete="off" />
          <button type="submit" className="routine-btn routine-btn--danger" disabled={Boolean(ocupado) || confirmacao !== 'CONFIRMAR'}>Confirmar exclusão</button>
        </form> : <button type="button" className="routine-btn routine-btn--danger" disabled={Boolean(ocupado)} onClick={() => setConfirmando(true)}>Excluir conta</button>)}
      </>}
      {erro && <p className="routine-callout__text" role="alert">{erro}</p>}
    </dialog>
  </div>;
}
